/**
 * @generated SignedSource<<3958545db4f0e69bc83814480648083f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type validationContainerFieldsQuery$variables = {
  containerId: number;
};
export type validationContainerFieldsQuery$data = {
  readonly validationContainerFields: ReadonlyArray<{
    readonly ID: number;
    readonly name: string;
    readonly nativeType: string | null;
    readonly type: string;
  } | null> | null;
};
export type validationContainerFieldsQuery = {
  response: validationContainerFieldsQuery$data;
  variables: validationContainerFieldsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      }
    ],
    "concreteType": "ValidationContainerField",
    "kind": "LinkedField",
    "name": "validationContainerFields",
    "plural": true,
    "selections": [
      {
        "alias": "ID",
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nativeType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "validationContainerFieldsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "validationContainerFieldsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f2b4f458f9f61ad9079709e61ab939d8",
    "id": null,
    "metadata": {},
    "name": "validationContainerFieldsQuery",
    "operationKind": "query",
    "text": "query validationContainerFieldsQuery(\n  $containerId: Int!\n) {\n  validationContainerFields(containerId: $containerId) {\n    ID: id\n    name\n    type\n    nativeType\n  }\n}\n"
  }
};
})();

(node as any).hash = "f21eb2ad0d70beee5c935b97f129aa4e";

export default node;
